import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useToast} from 'react-native-toast-notifications';
import {useModal} from 'extensions/viewport/useModal';
import {Prompt} from 'interface/base/Prompt';
import {rename, isFolderkey} from 'utils/mediafire';

export function useModalRename(id: string, name: string) {
  const {t} = useLingui();
  const modal = useModal();
  const toast = useToast();

  const submit = useCallback(async (value: string) => {
    if (value) {
      const res = await rename(id, value);
      if (res && res['result'] === 'Success') {
        toast.show(t`Renamed “${name}” to “${value}”`);
      } else {
        toast.show(res?.message ?? t`Failed to rename ${name}`, {type: 'danger'});
      }
    }
    modal.exit();
  }, [id, name]);

  const open = useCallback(() => {
    const isFolder = isFolderkey(id);
    modal.open(
      <Prompt
        title={t`Rename ${isFolder ? 'Folder' : 'File'}`}
        text={t`Give “${name}” a new name`}
        options={{
          type: 'plain-text',
          placeholder: name,
          defaultValue: name,
          selectInput: isFolder ? 'all' : 'filename',
        }}
        buttons={[
          {
            mode: 'primary',
            text: t`Ok`.toUpperCase(),
            onPress: submit,
          },
          {
            mode: 'cancel',
            text: t`Cancel`.toUpperCase(),
            onPress: modal.exit,
          },
        ]}
      />
    );
  }, [id, name]);

  return {open, exit: modal.exit};
}
